module.exports = __webpack_public_path__ + "static/media/ios-save.92b47c8d.svg";